//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

const getTwitterPostDetails = (state: ICuralateStore) =>
  state.twitter.postDetails;

export const getTwitterPostDetailsErrors = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.errors,
);

export const getTwitterPostDetailsValidationErrors = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.validationErrors,
);

export const getTwitterPostDetailsFlags = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.flags,
);

export const getTwitterPostDetailsPostId = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.postId,
);

export const getTwitterPostDetailsPostStatus = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.postStatus,
);

export const getTwitterCurrentPostDetails = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.currentPostDetails,
);

export const getTwitterScheduleEntryPoint = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.schedulingEntryPoint,
);

export const getTwitterPostDetailsDraftId = createSelector(
  getTwitterPostDetails,
  (postDetails) => postDetails.draftId,
);
